var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPhone = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4011 18.8393L19.8073 16.8706C19.611 16.7869 19.3929 16.7693 19.1858 16.8203C18.9787 16.8714 18.7937 16.9883 18.6588 17.1536L16.6244 19.6392C13.4316 18.1338 10.8621 15.5643 9.35673 12.3715L11.8423 10.3371C12.0079 10.2024 12.1251 10.0175 12.1761 9.81023C12.2272 9.60301 12.2094 9.38479 12.1253 9.18861L10.1565 4.59478C10.0643 4.3833 9.90117 4.21063 9.69526 4.10656C9.48935 4.00248 9.25358 3.97351 9.0286 4.02465L4.7629 5.00904C4.546 5.05913 4.35247 5.18126 4.21391 5.3555C4.07536 5.52974 3.99995 5.7458 4 5.96841C4 16.4891 12.5273 25 23.0316 25C23.2542 25.0001 23.4704 24.9248 23.6447 24.7862C23.819 24.6476 23.9412 24.4541 23.9913 24.2371L24.9757 19.9714C25.0265 19.7453 24.997 19.5086 24.8921 19.302C24.7872 19.0954 24.6136 18.9318 24.4011 18.8393ZM23.9994 19.7551L19.426 17.7951L16.9039 20.8765L16.1979 20.5437C12.7951 18.9393 10.0566 16.2008 8.45222 12.7979L8.11937 12.092L11.2008 9.5699L9.24288 5.00148L5 5.98061C5.00659 15.9389 13.0767 23.9936 23.0198 24L23.9994 19.7551Z",
    fill: "#111111"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/phone.1a4788a9.svg";
export { ForwardRef as ReactComponent };